import reducers from './reducers';
import { namespace } from './store';

export * from './actions';
export * from './saga';
export * from './selectors';
export * from './store';

export const userPermissionsReducers = {
  [namespace]: reducers,
};
